export default "__VITE_ASSET__CZ81Q73N__"